module.exports = __webpack_public_path__ + "img/stage_bg.20e62cb.jpg";